import styled from 'styled-components';
import { media } from '@payright/web-components';

export const SCBlueCheckbox = styled.div`
  display: flex;
  border-radius: 10px;
  padding: 1em 0.5em 2em 0;
  background-color: transparent !important;
  line-height: 1.625rem;
  div.blue-text {
    color: ${(props) => props.theme.colours.blue.base};
  }
  .check-wrapper > div.blue-text {
    line-height: 2.5;
  }

  check-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .multiline span.checkmark {
    background-color: unset;
  }

  ${media.max.tablet} {
    padding: 2.44em 2.44em 2.44em 0;
  }

  ${media.max.small} {
    padding: 1.5em 1.5em 1.5em 0;
    .check-wrapper {
      align-items: flex-start;
    }
  }
`;
